const $ = require('jquery');
const headerAnalytics = require('header.analytics');

class HeaderData {
  constructor() {
    this.level1 = {};
    this.level2 = {};
    this.level3 = {};
    this.subheaderNavLinks = [];
    this.dev = 'Dev';
    this.stage = 'Stage';
    this.devHostName = 'hd-qa71.homedepotdev.com';
    this.stageHostName = 'hd-qa74.homedepotdev.com';
    this._cacheLevel2Data = this._cacheLevel2Data.bind(this);
    this.dataLoaded = this._fetchFlyoutData();
  }

  _createLevel3Key(level1Name, level2Name) {
    return [level1Name, level2Name].join(':');
  }

  _cacheLevel3Data(level1Name, level2Name, level3Data) {
    const cacheKey = this._createLevel3Key(level1Name, level2Name);
    this.level3[cacheKey] = level3Data;
  }

  _cacheLevel1Data(flyoutResponse) {
    this.level1.categories = [];

    flyoutResponse.forEach((item) => {
      this.level1.categories.push({
        name: item.title ? item.title : '',
        link: item.link ? item.link : '',
        feature: item.feature ? item.feature : {},
      });
    });
  }

  // Most of this work could be a map, but support isn't there yet
  _cacheLevel2Data(categoryName, flyoutResponse) {
    let currentCategory;
    this.level2[categoryName] = [];

    for (let i = 0; i < flyoutResponse.length; i++) {
      currentCategory = flyoutResponse[i];
      this.level2[categoryName].push({
        flyoutLevel: 'level2',
        name: currentCategory.name ? currentCategory.name : '',
        url: currentCategory.url ? currentCategory.url : '',
      });

      const l3Array =
        typeof currentCategory.l3 !== 'undefined' ? currentCategory.l3 : [];
      this._cacheLevel3Data(categoryName, currentCategory.name, l3Array);
    }
  }

  _clearFlyoutData() {
    this.level1 = {};
    this.level2 = {};
    this.level3 = {};
  }

  _cacheFlyoutData(flyoutResponse) {
    const responseData = flyoutResponse.header.primaryNavigation
      ? flyoutResponse.header.primaryNavigation
      : [];
    this._clearFlyoutData();
    this.subheaderNavLinks = flyoutResponse.header.subheaderNavigationLinks
      ? flyoutResponse.header.subheaderNavigationLinks
      : [];
    this._cacheLevel1Data(responseData);
    for (let i = 0; i < responseData.length; i++) {
      this._cacheLevel2Data(responseData[i].title, responseData[i].l2);
    }
  }

  _createFlyoutRequestURL() {
    const hostName = this.getHostName();
    let environ;
    // Dev and Stage endpoints have a prefix before the flyout version that must be added to the URL for these environments
    if (hostName === this.devHostName) {
      environ = this.dev;
    } else if (hostName === this.stageHostName) {
      environ = this.stage;
    } else {
      environ = '';
    }
    return `//${hostName}/hdus/en_US/DTCCOMNEW/fetch/b2b-headerFooterFlyout-${environ}8.json?debug=true`;
  }

  _createFlyoutRequest(url) {
    return $.ajax({
      dataType: 'jsonp',
      url: url,
      jsonpCallback: 'staticFlyCallback',
      cache: true,
      timeout: 3000,
    });
  }

  _fetchFlyoutData() {
    return new Promise((resolve, reject) => {
      const url = this._createFlyoutRequestURL();
      this._createFlyoutRequest(url)
        .then((response) => {
          this._cacheFlyoutData(response);
          resolve();
        })
        .fail(() => {
          reject('Failed to load flyout data.');
        });
    });
  }

  _setBreakpointChangeListener() {
    const desktopMediaBreakpoint = '(min-width: 960px)';
    window.matchMedia(desktopMediaBreakpoint).onchange = (event) => {
      const channel = event.matches ? 'desktop' : 'mobile';
      $(document).trigger('breakpointChanged', [{ channel }]);
    };
  }

  /*
    In BETA and PROD this returns either
      * secure2.homedepot.com
      * www.homedepot.com
    *** until the secure2 retirement is completed. ***

    In the LLCs this returns the only possible hostname, respectively
      * hd-qa71.homedepotdev.com
      * hd-qa74.homedepotdev.com
  */
  getHostName() {
    const secureHostName =
      window.THD_GLOBAL && window.THD_GLOBAL.secureHostName;
    const nonSecureHostName =
      window.THD_GLOBAL && window.THD_GLOBAL.nonSecureHostName;
    return window.location.hostname === secureHostName
      ? secureHostName
      : nonSecureHostName;
  }

  getNavData() {
    return this.dataLoaded
      .then(() => {
        if (this.subheaderNavLinks && this.subheaderNavLinks.length) {
          return this.subheaderNavLinks;
        } else {
          return null;
        }
      })
      .catch((e) => {
        console.error('Could not get nav data');
        headerAnalytics.logError(`Error loading Nav Links: ${e}`);
        return Promise.reject();
      });
  }

  getLevel1Data() {
    return this.dataLoaded
      .then(() => {
        if (this.level1.categories && this.level1.categories.length) {
          return this.level1.categories;
        } else {
          return null;
        }
      })
      .catch((e) => {
        console.error('Could not get level 1 data');
        headerAnalytics.logError(`Error loading L1: ${e}`);
      });
  }

  getLevel2Data(level1Name) {
    return this.dataLoaded
      .then(() => {
        if (this.level2[level1Name] && this.level2[level1Name].length) {
          return this.level2[level1Name];
        }
        return null;
      })
      .catch((e) => {
        console.error('Could not get level 2 data');
        headerAnalytics.logError(`Error loading L2: ${e}`);
      });
  }

  getLevel3Data(level1Name, level2Name) {
    const cacheKey = this._createLevel3Key(level1Name, level2Name);
    return this.dataLoaded
      .then(() => {
        if (this.level3[cacheKey] && this.level3[cacheKey].length) {
          return this.level3[cacheKey];
        }
        return null;
      })
      .catch((e) => {
        console.error('Could not get level 3 data');
        headerAnalytics.logError(`Error loading L3: ${e}`);
      });
  }

  getMenuConfig() {
    const menuConfig = {
      departmentsFlyout: {
        name: 'departmentsFlyout',
        menuClass: 'MainFlyout',
        isActive: false,
      },
    };
    return menuConfig;
  }

  isNonThirdPartyPage() {
    const hostname = window.location.hostname;
    const hostnameFromTHDGlobals = this.getHostName();
    return hostname === 'localhost' || hostname === hostnameFromTHDGlobals;
  }

  init() {
    this._setBreakpointChangeListener();
  }
}

module.exports = new HeaderData();
